import React from "react";
import { useNavigate } from "react-router-dom";

export default function AffiliatePage() {
  const navigate = useNavigate();

  const handleApplyClick = () => {
    navigate("/affiliate/apply");
  };

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <div className="mb-4">
          <div
            className="bg-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
            style={{ width: "80px", height: "80px" }}
          >
            <i className="bi bi-people-fill text-white fs-2"></i>
          </div>
          <h1 className="display-5 fw-bold text-dark mb-3">
            Become an Affiliate
          </h1>
          <p className="lead text-muted">
            Join our affiliate program and earn generous commissions on every
            referral. Grow with us and maximize your earning potential.
          </p>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="card shadow-sm border-0 rounded-3 overflow-hidden">
            <div className="card-header bg-primary text-white py-4">
              <h4 className="card-title mb-0 text-center">
                <i className="bi bi-star-fill me-2"></i>
                Affiliate Program Benefits
              </h4>
            </div>
            <div className="card-body p-4">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex align-items-start mb-4">
                    <div
                      className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                      style={{ width: "50px", height: "50px" }}
                    >
                      <i className="bi bi-cash-coin text-success fs-4"></i>
                    </div>
                    <div>
                      <h5 className="fw-semibold mb-1">
                        Generous Commission Structure
                      </h5>
                      <p className="text-muted mb-0">
                        Earn competitive rates on every sale
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="d-flex align-items-start mb-4">
                    <div
                      className="bg-info bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                      style={{ width: "50px", height: "50px" }}
                    >
                      <i className="bi bi-graph-up text-info fs-4"></i>
                    </div>
                    <div>
                      <h5 className="fw-semibold mb-1">Real-time Tracking</h5>
                      <p className="text-muted mb-0">
                        Monitor your performance live
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="d-flex align-items-start mb-4">
                    <div
                      className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                      style={{ width: "50px", height: "50px" }}
                    >
                      <i className="bi bi-tools text-warning fs-4"></i>
                    </div>
                    <div>
                      <h5 className="fw-semibold mb-1">Marketing Resources</h5>
                      <p className="text-muted mb-0">
                        Access banners, links & promotional materials
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="d-flex align-items-start mb-4">
                    <div
                      className="bg-purple bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                      style={{ width: "50px", height: "50px" }}
                    >
                      <i className="bi bi-shield-check text-purple fs-4"></i>
                    </div>
                    <div>
                      <h5 className="fw-semibold mb-1">Reliable Payments</h5>
                      <p className="text-muted mb-0">
                        Timely and secure commission payments
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center mt-4 pt-3 border-top">
                <h5 className="mb-3">Ready to get started?</h5>
                <p className="text-muted mb-4">
                  Join our community of successful affiliates already earning
                  with us
                </p>
                <button
                  className="btn btn-primary btn-lg px-5 rounded-pill fw-semibold"
                  onClick={handleApplyClick}
                >
                  <i className="bi bi-pencil-fill me-2"></i>
                  Apply Now
                </button>
                <p className="text-muted small mt-3">
                  No upfront costs • Simple application • Start earning quickly
                </p>
              </div>
            </div>
          </div>

          {/* Stats Section */}
          <div className="row mt-5 text-center">
            <div className="col-md-4 mb-4">
              <div className="bg-light rounded-3 p-4 h-100">
                <i className="bi bi-currency-dollar fs-1 text-primary mb-3"></i>
                <h3 className="fw-bold text-primary">-</h3>
                <p className="text-muted mb-0">Total commissions paid</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="bg-light rounded-3 p-4 h-100">
                <i className="bi bi-people fs-1 text-success mb-3"></i>
                <h3 className="fw-bold text-success">-</h3>
                <p className="text-muted mb-0">Active affiliates</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="bg-light rounded-3 p-4 h-100">
                <i className="bi bi-globe fs-1 text-info mb-3"></i>
                <h3 className="fw-bold text-info">-</h3>
                <p className="text-muted mb-0">Countries reached</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
